import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { Movie } from '../../services/Page/page.service';
import { Booking } from '../../services/Booking/booking.service';
import { DateRangePipe } from "../../pipes/date-range.pipe";
import { RouterModule } from '@angular/router';
import { AddComponent } from "../UI/add/add.component";

@Component({
    selector: 'app-booking-card',
    imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    DateRangePipe,
    AddComponent
],
    templateUrl: './booking-card.component.html',
    styleUrl: './booking-card.component.scss'
})
export class BookingCardComponent {
    @Input('booking')
    booking!: Booking; 
    @Output('cancel') cancel = new EventEmitter<Booking>();
    @Input('isCancellable') isCancellable : boolean = false

    constructor() {

    }

    onCancel() {
        this.cancel.emit(this.booking)
    }
}
